import React from "react";
import { Link } from "react-router-dom";
import heroImage from "../Assests/Image.jpg";
import image1 from "../Assests/Image1.jpg";
import image2 from "../Assests/Image2.jpg";
import image3 from "../Assests/Image3.jpg";
import image4 from "../Assests/Image4.jpg";
import image5 from "../Assests/Image5.jpg";
import image6 from "../Assests/Image6.jpg";

const highlightProducts = [
  {
    title: "Premium Nadu / Samba",
    notes: "Soft, fluffy texture ideal for everyday Sri Lankan meals.",
    specs: ["White or red raw rice", "5kg | 10kg | 25kg bags", "Moisture <= 13%", "Broken <= 5%"],
  },
  {
    title: "Keeri Samba & Basmati",
    notes: "Aromatic grains for celebratory biriyani and fried rice.",
    specs: ["Extra-clean, low-starch polish", "5kg & 10kg consumer packs", "Export-ready grading"],
  },
  {
    title: "Red Raw & Red Samba",
    notes: "Nutrient-rich, unpolished options for health-focused menus.",
    specs: ["High-fiber raw finish", "Retail and hotel packs", "Strict sorting for fewer husks"],
  },
  {
    title: "Parboiled / Steamed Rice",
    notes: "Firm grains that stay separate after cooking in kitchens & hotels.",
    specs: ["Consistency across batches", "10kg | 25kg catering packs", "Lab-checked cleanliness"],
  },
];

const processSteps = [
  { title: "Sourcing", text: "Partner paddy fields in Anuradhapura, Polonnaruwa, and Kurunegala." },
  { title: "Cleaning", text: "Triple-clean optical sorting to remove husk, stones, and foreign matter." },
  { title: "Milling", text: "Modern rubber roll milling calibrated for minimal breakage and sheen." },
  { title: "Quality", text: "Daily moisture, whiteness, and grain-length checks by in-house lab." },
  { title: "Delivery", text: "Temperature-controlled storage and scheduled dispatch across Sri Lanka." },
];

const galleryShots = [
  { title: "Golden harvest ready for milling", src: image1 },
  { title: "Sorting and cleaning lines", src: image2 },
  { title: "Freshly milled white rice", src: image3 },
  { title: "Red raw and red samba grains", src: image4 },
  { title: "Quality control and grading", src: image5 },
  { title: "Packed and dispatch-ready", src: image6 },
];

function Home() {
  return (
    <div className="page home">
      <section
        className="hero"
        style={{
          backgroundImage: `linear-gradient(120deg, rgba(17, 51, 34, 0.78), rgba(12, 86, 67, 0.62)), url(${heroImage})`,
        }}
      >
        <div className="hero__content">
          <p className="eyebrow">Sri Lankan Rice Specialists</p>
          <h1>From paddy to plate - freshly milled, packed, and delivered.</h1>
          <p className="hero__lead">
            Rajarata Rice Mills sources the best harvest from the North Central and North Western provinces,
            mills daily, and ships premium grains to hotels, caterers, and families island-wide.
          </p>
          <div className="hero__actions">
            <a className="btn btn--primary" href="tel:+94771234567">
              Talk to Sales
            </a>
            <Link className="btn btn--ghost" to="/products">
              View Product Range
            </Link>
          </div>
          <div className="hero__stats">
            <div>
              <strong>25+</strong>
              <span>Years milling experience</span>
            </div>
            <div>
              <strong>1000+</strong>
              <span>Retailers supplied</span>
            </div>
            <div>
              <strong>ISO</strong>
              <span>Clean-room storage</span>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section__heading">
          <p className="eyebrow">Our Portfolio</p>
          <h2>Rice crafted for every Sri Lankan kitchen</h2>
          <p>
            Consistent texture, fragrance, and polish - curated for home cooks, restaurants, caterers, and export
            buyers who demand dependable quality.
          </p>
        </div>
        <div className="grid grid--4">
          {highlightProducts.map((product) => (
            <div className="card product-card" key={product.title}>
              <div className="card__header">
                <h3>{product.title}</h3>
                <p>{product.notes}</p>
              </div>
              <ul className="pill-list">
                {product.specs.map((item) => (
                  <li key={item} className="pill">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="section section--tint">
        <div className="section__heading">
          <p className="eyebrow">How we work</p>
          <h2>Meticulous processing from field to finished grain</h2>
          <p>Every batch is tracked, tested, and packed to meet demanding buyers across Sri Lanka.</p>
        </div>
        <div className="grid grid--5">
          {processSteps.map((step) => (
            <div className="card step-card" key={step.title}>
              <h4>{step.title}</h4>
              <p>{step.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="section__heading">
          <p className="eyebrow">Gallery</p>
          <h2>From paddy fields to the packing line</h2>
          <p className="muted">
            A quick look at the harvests we source, the care we take in cleaning and milling, and the polished grains
            that leave our facility.
          </p>
        </div>
        <div className="gallery-grid">
          {galleryShots.map((shot) => (
            <div className="gallery-card" key={shot.title}>
              <img src={shot.src} alt={shot.title} />
              <span>{shot.title}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="section__split">
          <div>
            <p className="eyebrow">Why Rajarata</p>
            <h2>Local expertise, export-grade standards</h2>
            <ul className="checklist">
              <li>Fresh-milled daily to lock in aroma and reduce breakage.</li>
              <li>Moisture, foreign matter, and grain-length tests for every lot.</li>
              <li>Custom packing: consumer poly bags, woven sacks, or private label.</li>
              <li>Island-wide delivery with reliable schedules for hotels and supermarkets.</li>
              <li>Dedicated account managers for bulk and export orders.</li>
            </ul>
            <div className="callout">
              <strong>Need a sample?</strong>
              <span>We can arrange sample packs for chefs, buyers, and distributors.</span>
            </div>
          </div>
          <div className="highlight-panel">
            <div className="highlight-panel__badge">Sri Lanka</div>
            <h3>Trusted by kitchens from Colombo to Jaffna</h3>
            <p>
              Our blends are tailored to local tastes - fluffy Samba for lunch plates, aromatic Keeri for biriyani, and
              wholesome red raw for wellness menus.
            </p>
            <div className="metrics">
              <div>
                <strong>5</strong>
                <span>Packaging formats</span>
              </div>
              <div>
                <strong>48h</strong>
                <span>Avg. dispatch lead time</span>
              </div>
              <div>
                <strong>Zero</strong>
                <span>Compromise on cleanliness</span>
              </div>
            </div>
            <Link className="btn btn--secondary" to="/contact">
              Get a quotation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
